export default class Blog {
    constructor(element) {
        this.readMoreBtn = element.querySelector('.js-blog-read-more')
        this.blogItems = element.querySelectorAll('.js-blog-item')

        if (this.readMoreBtn) {
            this.readMoreBtn.addEventListener('click', (e) => {
                e.preventDefault()
                this.readMoreFunc(this.readMoreBtn, this.blogItems, element)
            })
        }
    }
    readMoreFunc(button, items, element) {
        this.hiddenItems = Array.from(element.querySelectorAll('.js-blog-item.hidden'))
        this.firstNew = this.hiddenItems.slice(0, 4)
        this.remainingItems = this.hiddenItems.slice(4)
        this.firstNew.forEach((item) => {
            item.classList.remove('hidden')
        })
        if (this.remainingItems.length <= 0) {
            button.classList.add('hidden')
        }
    }
}
